'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _bibShape = require('./bibShape');

var _bibShape2 = _interopRequireDefault(_bibShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reactImmutableProptypes2.default.mapContains({
  actions: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  bib: _bibShape2.default,
  checkInEnabled: _react.PropTypes.bool,
  checkoutId: _react.PropTypes.string,
  digitalId: _react.PropTypes.string,
  downloadUrl: _react.PropTypes.string,
  downloadable: _react.PropTypes.bool,
  dueDate: _react.PropTypes.string,
  fines: _react.PropTypes.number,
  format: _react.PropTypes.string,
  materialType: _react.PropTypes.string,
  metadataId: _react.PropTypes.string,
  status: _react.PropTypes.string,
  thirdPartyReaderUrl: _react.PropTypes.string,
  timesRenewed: _react.PropTypes.number
});


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/checkedOutItemShape.js
// module id = 353
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15